/* eslint-disable */
export default {
  'WH.messageBus': [
    /^(http|https)(\:\/\/)(www\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com|\.es)(\/|\/en-gb|\/es|\/pt|\/fi|\/de-de|\/ja-jp|\/cs|\/hu|\/sl|\/ro|\/sr|\/ru-ru|\/el-gr|\/zh-cn|\/zh-hk|\/fr-fr|\/pl-pl){0,1}/i,
    /^(http|https)(\:\/\/)(sports\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/betting\/)(de-de|en-gb|sv-se|el-gr|ru-ru|ja-jp)/i,
    /^(http|https)(\:\/\/)(sports\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.es)(\/betting\/)(es-es)/i,
    /^(http|https)(\:\/\/)(sports\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.it)(\/betting\/)(it-it)/i,
    /^(http|https)(\:\/\/)(vegas\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/en-gb)/i,
    /^(http|https)(\:\/\/)(livecasino\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca){0,1}/i,
    /^(http|https)(\:\/\/)(casino\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca|\/de-de|\/ru-ru|\/ja-jp|\/en-ca|\/sv-se|\/pl-pl|\/fr-fr){0,1}/i,
    /^(http|https)(\:\/\/)(games\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca|\/de-de|\/ru-ru|\/ja-jp|\/sv-se|\/pl-pl|\/el-gr|\/fr-fr){0,1}/i,
    /^(http|https)(\:\/\/)(bingo\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/en-gb)/i,
    /^(http|https)(\:\/\/)(promotions\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-gb|\/ru-ru|\/ja-jp|\/de-de){0,1}/i,
    /^(http|https)(\:\/\/)(promociones\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.es)/i,
    /^(http|https)(\:\/\/)(macau\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|\/en-ie|\/en-ca|\/de-de|\/ru-ru|\/ja-jp|\/sv-se|\/pl-pl|\/el-gr|\/fr-fr){0,1}/i,
    /^(http|https)(\:\/\/)(localhost)/i,
  ],
  AnalyticsPubSub: [
    /^(http|https)(\:\/\/)(vegas\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/)(es|sv|de|ja|ru|cn|zh|fr|pl)(\/live-casino)/i,
    /^(http|https)(\:\/\/)(games\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com\/)(es|cn|zh)(\/index)/i,
    /^(http|https)(\:\/\/)(poker\.williamhill)(-pp1|-pp2|-pp3){0,1}(\.com)(\/|(\/pt|\/ie|\/sv|\/fi|\/de|\/ja|\/cs|\/hu|\/sl|\/ro|\/sr|\/ru|\/es)\/index){0,1}/i,
  ],
};



// WEBPACK FOOTER //
// ./src/main/messageBusMap.js